import { memo } from 'react';

import { useAppDispatch, useAppSelector, useTranslate } from 'hooks';
import { readAllNews } from 'features/news/actions/readAllNews';
import { getUserProfile } from 'features/user/actions';
import { getLanguage } from 'utils';
import { selectUser } from 'selectors';

import s from './index.module.scss';

export const ReadAllNews = memo(() => {
	const user = useAppSelector(selectUser);
	const dispatch = useAppDispatch();
	const { readAllText } = useTranslate(['readAllText']);

	const onClick = async () => {
		await dispatch(readAllNews(getLanguage()))
			.unwrap()
			.then(() => {
				dispatch(getUserProfile());
			});
	};

	if (user.news?.unreadCount === 0) return null;

	return (
		<button className={s.read} onClick={onClick}>
			{readAllText}
		</button>
	);
});
